import React from 'react';
import { Navigate } from 'react-router-dom';
import MasterStocks from '../components/MasterStocks';

const MasterStocksPage = ({ user }) => {
  if (!['superadmin', 'admin'].includes(user?.role)) {
    return <Navigate to="/services" replace />;
  }

  return <MasterStocks user={user} />;
};

export default MasterStocksPage;
